import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Send } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { useState } from 'react';

interface DCEmailModalProps {
    open: boolean;
    onClose: () => void;
}

export const DCEmailModal = ({ open, onClose }: DCEmailModalProps) => {
    const record = useRecordContext();
    const [to, setTo] = useState('');
    const [subject, setSubject] = useState(`Delivery Challan ${record?.reference ?? ''}`);
    const [body, setBody] = useState(
        `Dear Sir/Madam,\n\nPlease find attached the Delivery Challan ${record?.reference ?? ''} for your reference.\n\nKindly acknowledge receipt.\n\nRegards,\nRovasys Allied Works Pvt. Ltd.`
    );
    const [sending, setSending] = useState(false);

    const handleSend = async () => {
        setSending(true);
        // TODO: Call Supabase Edge Function `send_document_email`
        // await fetch('/functions/v1/send_document_email', { method: 'POST', body: JSON.stringify({ document_type: 'delivery_challan', document_id: record?.id, recipient_email: to, subject, body }) })
        setTimeout(() => {
            setSending(false);
            onClose();
        }, 800);
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="max-w-lg">
                <DialogHeader>
                    <DialogTitle>Send Delivery Challan</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <div>
                        <Label>To</Label>
                        <Input value={to} onChange={e => setTo(e.target.value)} placeholder="recipient@customer.com" />
                    </div>
                    <div>
                        <Label>Subject</Label>
                        <Input value={subject} onChange={e => setSubject(e.target.value)} />
                    </div>
                    <div>
                        <Label>Message</Label>
                        <Textarea value={body} onChange={e => setBody(e.target.value)} rows={6} />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Cancel</Button>
                    <Button onClick={handleSend} disabled={!to || sending}>
                        <Send className="w-4 h-4 mr-2" />
                        {sending ? 'Sending…' : 'Send'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
